module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/demo11/bg-1-821bf3c3375e747be6c6d14e0451c85a.jpg";